import { FREE_LISTING_TYPE, MANDATO_LISTING_TYPE } from '../../config/configListing';

/** Four market intentions, backed by the existing listing types and indexed operations. */
export const HOME_OPPORTUNITIES = [
  { key: 'sell', listingType: FREE_LISTING_TYPE, operations: ['venta-total'] },
  { key: 'buy', listingType: MANDATO_LISTING_TYPE, operations: ['venta-total'] },
  {
    key: 'capital',
    listingType: FREE_LISTING_TYPE,
    operations: ['inversor-minoritario', 'inversor-mayoritario'],
  },
  {
    key: 'invest',
    listingType: MANDATO_LISTING_TYPE,
    operations: ['inversor-minoritario', 'inversor-mayoritario'],
  },
];

/** Filter before limiting: a sparse category must still return its actual newest listing. */
export const opportunityQuery = ({ listingType, operations }) => ({
  pub_listingType: listingType,
  [listingType === MANDATO_LISTING_TYPE
    ? 'pub_tiposOperacion'
    : 'pub_tipo_operacion']: `has_any:${operations.join(',')}`,
  sort: 'createdAt',
  per_page: 1,
  'fields.listing': ['title', 'publicData', 'createdAt'],
});
